import { transformChannelGroupWrapper } from '~/src/dash/api/channel-group';
import { IChannelGroup } from '~/src/dash/api/console-api';
import {
  parseArray,
  parseNumber,
  parseString,
  transformModel,
} from '~/src/dash/api/resource-transforms';

export interface IChannelGroupLabel {
  ID: string;
  CreatedAt: string;
  UpdatedAt?: string;
  DeletedAt?: string;
  Name: string;
  ChannelGroups: IChannelGroup[];
}

// transformChannelGroupLabelFromAPI transforms an IChannelGroupLabel from the API for the UI
export const transformChannelGroupLabelFromAPI = transformModel<IChannelGroupLabel>({
  ID: parseNumber(['ID']),
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  DeletedAt: 'DeletedAt',
  Name: parseString(['Name']),
  ChannelGroups: parseArray(['ChannelGroups', 'channelgroups'], transformChannelGroupWrapper),
});

// transformChannelGroupLabelToAPI transforms an IChannelGroupLabel from the UI for the API
export const transformChannelGroupLabelToAPI = transformModel<IChannelGroupLabel>({
  ID: parseNumber(['ID']),
  Name: parseString(['Name']),
  ChannelGroups: parseArray(['ChannelGroups', 'channelgroups'], transformChannelGroupWrapper),
});
